import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";

export function useSalesInsightThreadsAll(businessId: string | undefined) {
  const trpc = useTRPC();
  return useQuery(
    trpc.salesTeams.listThreads.queryOptions(
      { businessId: businessId ?? "" },
      { enabled: Boolean(businessId) },
    ),
  );
}

export function useSalesInsightThread(
  businessId: string | undefined,
  threadId: string | undefined | null,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.salesTeams.getThread.queryOptions(
      { businessId: businessId ?? "", threadId: threadId ?? "" },
      { enabled: Boolean(businessId && threadId) },
    ),
  );
}
